import React from "react";

const SectionRichText = ({richText, ...other}) => (
  <div className="section__entry richtext-entry" dangerouslySetInnerHTML={{ __html: richText }} {...other}></div>
);

export default SectionRichText;